import type { CommandData } from '../types'

export function setPrefilledVariables(variables: Record<string, string | number | boolean>) {
  const message: CommandData = {
    isFromNetwatch: true,
    command: 'setPrefilledVariables',
    variables,
  }
  window.postMessage(message)
}
